// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#viewtoggle[data-v-5f2de54b] {\n  position: absolute;\n  left: calc(100vw - 400px);\n  top: 190px;\n  z-index: 4;\n}\n", ""]);
// Exports
module.exports = exports;
